import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path, Circle } from '../IconBase/IconBase'

function DoubleArrowRefresh({
  color = 'icon.white',
  stroke = '1.5',
  fill = 'none',
  ...props
}) {
  return (
    <IconBase
      viewBox='0 0 18 18'
      fill='none'
      {...props}
    >
      <Circle
        cx='9'
        cy='9'
        r='9'
        fill={fill}
        strokeWidth={stroke}
      />
      <Path
        d='
          M13.7107 6.07812
          L12.8947 7.7111
          L11.2617 6.8951
        '
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
        strokeWidth={stroke}
      />
      <Path
        d='
          M5.51562 5.19542
          C6.68692 4.0213 8.42408 3.61567 9.99422 4.14966
          C11.5644 4.68365 12.694 6.06427 12.9066 7.70905
        '
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
        color='red'
        fill={fill}
        strokeWidth={stroke}
      />
      <Path
        d='
          M3.91797 11.5588
          L4.73397 9.92578
          L6.36695 10.7418
        '
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
        strokeWidth={stroke}
      />
      <Path
        d='
          M12.1215 12.4394
          C10.9502 13.6135 9.21303 14.0192 7.64289 13.4852
          C6.07275 12.9512 4.94308 11.5706 4.73047 9.92578
        '
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
        strokeWidth={stroke}
      />
    </IconBase>
  )
}

DoubleArrowRefresh.propTypes = {
  color: PropTypes.string,
  stroke: PropTypes.string,
  fill: PropTypes.string,
}

export default DoubleArrowRefresh
